import {
  EventProps,
  HttpErrorCodesProps,
  HttpSuccessCodesProps,
  ProfileTypeProps,
} from "../types";
import FlutterwaveLogoFull from "../../Assets/IMG/flutterwave-full.svg";
import FlutterwaveLogoSmall from "../../Assets/IMG/flutterwave-small.svg";
import StripeLogo from "../../Assets/IMG/stripe.png";
import PaystackLogo from "../../Assets/IMG/paystack.png";

export const AppName = "Emril Academy";

export const OperationMode: "live" | "test" = "live";

export const ContactInformation = {
  email: "info@emrilacademy.com",
  whatsapp:
    "https://api.whatsapp.com/send?phone=447723864092&text=Hi%20Emril%20Academy%2C",
};
export const Colors = {
  BlackPrimary: "var(--black-primary)",
  BluePrimary: "var(--blue-primary)",
  BlueSecondary: "var(--blue-secondary)",

  PurplePrimary: "var(--purple-primary)",
  PurpleSecondary: "var(--purple-secondary)",
  PurpleTertiary: "var(--purple-tertiary)",

  GreenLight: "var(--green-light)",
  GreenPrimary: "var(--green-primary)",
  GreenSecondary: "var(--green-secondary)",

  GrayPrimary: "var(--gray-primary)",

  GrayTertiary: "var(--gray-tertiary)",
  GraySecondary: "var(--gray-secondary)",
  White: "var(--white-primary)",
  WhiteBlueTransparent: "var(--white-blue-transparent)",
  RedPrimary: "var(--red-primary)",
  OrangePrimary: "var(--orange-primary)",
  OrangeSecondary: "var(--orange-secondary)",
  Transparent: "var(--transparent)",
};
export const ValidIDLength = 32;
export { StripeLogo, FlutterwaveLogoFull, FlutterwaveLogoSmall, PaystackLogo };

export const HttpSuccessCodes: HttpSuccessCodesProps[] = [200, 201];
export const HttpErrorCodes: HttpErrorCodesProps[] = [
  400, 401, 402, 403, 404, 409, 500,
];

export const HttpSuccessCodesObj = {
  Success: 200,
  Created: 201,
  Accepted: 202,
  NoContent: 204,
};
export const HttpErrorCodesObj = {
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  InternalServerError: 500,
  UnprocessableEntity: 422,
  Expired: 410,
};

export const ValidOtpLength = 6;
export const OtpWaitTime = 5;
export const ValidPasswordLength = 8;

export const AdminRolesList = [
  { label: "Super Admin", value: "superadmin" },
  { label: "Admin", value: "admin" },
];

export const ProfileTypesList: ProfileTypeProps[] = [
  "student",
  "teacher",
  "admin",
];

export const YesOrNoList = [
  { label: "Yes", value: "yes", alternativeLabel: "Active" },
  { label: "No", value: "no", alternativeLabel: "Inactive" },
];

export const AppDomain = "emrilacademy.com";
export const AppLocation = "10 Adeyemi Odukomaya, Magodo, Lagos, Nigeria";

export const SocialMediaLinks = {
  instagram: "https://www.instagram.com/emrilacademy?igsh=MXNqeGRocWUxemRmOQ==",
  linkedin: "https://www.linkedin.com/company/emrilacademy",
  youtube: "https://www.youtube.com/channel/UC3pxcZhT5f8jvr4DXHrJWLQ",
  facebook: "https://www.facebook.com/share/16mwyHNRNh/",
  twitter: "https://x.com/emrilacadamy?t=R1TF2L6gzD3oUcSa8rzg7w&s=09",
};
// export const mockEvents: EventProps[] = [
//   {
//     id: "1",
//     title: "AI-Powered Learning: Future of Education",
//     description:
//       "Discover how artificial intelligence is revolutionizing online education. Learn about adaptive learning systems, personalized content delivery, and AI-driven assessments that are transforming how students learn.",
//     date: "2024-03-15",
//     time: "14:00",
//     location: "Virtual Event",
//     type: "webinar",
//     capacity: 500,
//     registered: 342,
//     price: 0,
//     featured: true,
//     image:
//       "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop&crop=center",
//     organizer: {
//       name: "Dr. Sarah Chen",
//       avatar:
//         "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
//       title: "AI Education Research Director",
//     },
//     tags: ["AI", "Machine Learning", "EdTech", "Innovation"],
//     difficulty: "intermediate",
//     duration: "2 hours",
//     language: "English",
//     certificationOffered: true,
//   },
//   {
//     id: "2",
//     title: "Full-Stack Web Development Bootcamp",
//     description:
//       "Intensive 3-day bootcamp covering React, Node.js, MongoDB, and deployment strategies. Build real-world projects and get hands-on experience with modern web development tools and frameworks.",
//     date: "2024-03-22",
//     time: "09:00",
//     location: "San Francisco Tech Hub",
//     type: "bootcamp",
//     capacity: 50,
//     registered: 47,
//     price: 299,
//     featured: true,
//     image:
//       "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=800&h=400&fit=crop&crop=center",
//     organizer: {
//       name: "Marcus Rodriguez",
//       avatar:
//         "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
//       title: "Senior Full-Stack Developer",
//     },
//     tags: ["React", "Node.js", "MongoDB", "JavaScript", "Career"],
//     difficulty: "beginner",
//     duration: "3 days",
//     language: "English",
//     certificationOffered: true,
//   },
//   {
//     id: "3",
//     title: "UX/UI Design Masterclass: From Zero to Hero",
//     description:
//       "Master the fundamentals of user experience and interface design. Learn design thinking, prototyping, user research, and create a portfolio project using industry-standard tools like Figma.",
//     date: "2024-03-28",
//     time: "16:00",
//     location: "Virtual Event",
//     type: "masterclass",
//     capacity: 200,
//     registered: 156,
//     price: 149,
//     featured: false,
//     image:
//       "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=800&h=400&fit=crop&crop=center",
//     organizer: {
//       name: "Elena Kowalski",
//       avatar:
//         "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
//       title: "Lead UX Designer at TechCorp",
//     },
//     tags: ["UX", "UI", "Design", "Figma", "Portfolio"],
//     difficulty: "beginner",
//     duration: "4 hours",
//     language: "English",
//     certificationOffered: true,
//   },
//   {
//     id: "4",
//     title: "Data Science & Analytics Workshop",
//     description:
//       "Deep dive into data science fundamentals using Python, pandas, and machine learning. Analyze real datasets and build predictive models. Perfect for aspiring data scientists and analysts.",
//     date: "2024-04-05",
//     time: "10:00",
//     location: "New York Data Center",
//     type: "workshop",
//     capacity: 75,
//     registered: 62,
//     price: 199,
//     featured: true,
//     image:
//       "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop&crop=center",
//     organizer: {
//       name: "Dr. Raj Patel",
//       avatar:
//         "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
//       title: "Senior Data Scientist",
//     },
//     tags: ["Python", "Data Science", "Machine Learning", "Analytics"],
//     difficulty: "intermediate",
//     duration: "6 hours",
//     language: "English",
//     certificationOffered: true,
//   },
//   {
//     id: "5",
//     title: "Cybersecurity Fundamentals Conference",
//     description:
//       "Stay ahead of cyber threats with this comprehensive conference covering network security, ethical hacking, incident response, and compliance frameworks. Network with security professionals.",
//     date: "2024-04-12",
//     time: "09:00",
//     location: "Austin Convention Center",
//     type: "conference",
//     capacity: 300,
//     registered: 278,
//     price: 399,
//     featured: false,
//     image:
//       "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=400&fit=crop&crop=center",
//     organizer: {
//       name: "James Thompson",
//       avatar:
//         "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop&crop=face",
//       title: "Cybersecurity Consultant",
//     },
//     tags: ["Security", "Hacking", "Network", "Compliance"],
//     difficulty: "advanced",
//     duration: "2 days",
//     language: "English",
//     certificationOffered: true,
//   },
//   {
//     id: "6",
//     title: "Digital Marketing & Growth Strategies",
//     description:
//       "Learn modern digital marketing techniques including SEO, social media marketing, content strategy, and conversion optimization. Hands-on exercises with real campaign data.",
//     date: "2024-04-18",
//     time: "13:00",
//     location: "Virtual Event",
//     type: "seminar",
//     capacity: 150,
//     registered: 89,
//     price: 99,
//     featured: false,
//     image:
//       "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=800&h=400&fit=crop&crop=center",
//     organizer: {
//       name: "Lisa Zhang",
//       avatar:
//         "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face",
//       title: "Digital Marketing Director",
//     },
//     tags: ["Marketing", "SEO", "Social Media", "Growth"],
//     difficulty: "beginner",
//     duration: "3 hours",
//     language: "English",
//     certificationOffered: false,
//   },
// ];

export const mockEvents: EventProps[] = [];
